module.exports = __webpack_public_path__ + "static/media/logo-heig-vd.d5dccb0a.svg";